import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Header from "./component/Header/Header";
import About from "./pages/About/About";

function App() {
  return (
    <>
      <Router>
        <Header/> 
        <Routes>
          <Route path="/about" element={<About/>}></Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
